export default __webpack_public_path__ + "static/media/dehygarlic.9e071073.jpg";